import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, MapPin, Award, Star } from "lucide-react";
import { SITE } from "../../site.config";
import { TOTAL_REVIEWS, STAR_AVERAGE } from "../../data/reviews";

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="relative bg-black border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
        <div
          data-testid="trust-badge-0"
          className="flex items-center gap-3 text-white/80"
        >
          <ShieldCheck className="w-6 h-6 text-cyan-pz shrink-0" />
          <span className="bebas tracking-[0.18em] text-base md:text-lg">
            {SITE.trustBadges[0]}
          </span>
        </div>

        <div
          data-testid="trust-badge-1"
          className="flex items-center gap-3 text-white/80"
        >
          <MapPin className="w-6 h-6 text-cyan-pz shrink-0" />
          <span className="bebas tracking-[0.18em] text-base md:text-lg">
            {SITE.trustBadges[1]}
          </span>
        </div>

        <div
          data-testid="trust-badge-2"
          className="flex items-center gap-3 text-white/80"
        >
          <Award className="w-6 h-6 text-cyan-pz shrink-0" />
          <span className="bebas tracking-[0.18em] text-base md:text-lg">
            {SITE.trustBadges[2]}
          </span>
        </div>

        <Link
          to="/reviews"
          data-testid="trust-badge-google-reviews"
          className="flex items-center gap-3 text-white/80 hover:text-cyan-pz transition-colors group"
        >
          <div className="flex gap-0.5 shrink-0">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                className="w-3.5 h-3.5 fill-cyan-pz text-cyan-pz"
              />
            ))}
          </div>
          <span className="bebas tracking-[0.18em] text-base md:text-lg group-hover:text-cyan-pz">
            {STAR_AVERAGE} • {TOTAL_REVIEWS}+ Google Reviews
          </span>
        </Link>
      </div>
    </section>
  );
}
